/**
 * 打印功能
 * @param {String} pageName 打印时页面名称
 * @param {String} printElementId 需要打印的元素id
 *
 * 1. 获取需要打印的元素
 * 2. 提取 v-text-field v-textarea的值到纯文本元素
 * 3. 获取页面的 head 内容
 * 4. 写入 head 内容和打印内容
 * 5. 等待新窗口的内容加载
 * 6. 执行打印操作
 * 注意使用时需要在页面中添加一个隐藏的 iframe
 *  <iframe
      ref="printFrame"
      style="visibility: hidden; position: absolute"
    ></iframe>
 */
export default {
  methods: {
    async printElement(pageName = '', printElementId = 'main-content') {
      // 获取需要打印的元素
      const printElement = document
        .getElementById(printElementId)
        .cloneNode(true)

      const titleText = pageName
      const titleElement = document.createElement('h1')
      //   titleElement.classList.add('print-title')
      titleElement.innerText = titleText
      printElement.insertBefore(titleElement, printElement.firstChild)

      const elementsToHide = printElement.querySelectorAll(
        '.d-print-none, .v-btn',
      )
      elementsToHide.forEach((element) => {
        element.parentNode.removeChild(element)
      })

      // 提取 v-text-field v-textarea的值到纯文本元素
      const textFields = printElement.querySelectorAll(
        '.v-text-field, .v-textarea',
      )
      textFields.forEach((textField) => {
        const label = textField.querySelector('label')
        const input = textField.querySelector('input')
        if (label) {
          const labelValueElement = document.createElement('div')
          labelValueElement.classList.add('print-text-field-label-value')
          labelValueElement.innerText = `${label.textContent}: ${
            input?.value || input?.previousElementSibling?.innerText || ''
          }`
          textField.parentNode.replaceChild(labelValueElement, textField)
        }
      })
      // 提取 v-switch v-textarea的值到纯文本元素
      const switchFields = printElement.querySelectorAll(' .v-input--switch')
      switchFields.forEach((switchField) => {
        const label = switchField.querySelector('label')
        if (label) {
          const labelValueElement = document.createElement('div')
          labelValueElement.classList.add('print-text-field-label-value')
          labelValueElement.innerText = label.textContent
          switchField.parentNode.replaceChild(labelValueElement, switchField)
        }
      })

      const printContent = printElement.outerHTML

      // 获取页面的 head 内容
      const headContent = document.head.outerHTML

      const printFrame = this.$refs.printFrame
      const printFrameDocument = printFrame.contentWindow.document
      printFrameDocument.open()

      // 写入 head 内容和打印内容
      printFrameDocument.write(`
    <!DOCTYPE html>
    <html>
      ${headContent}
      <body>
        ${printContent}
      </body>
    </html>
  `)

      // 等待新窗口的内容加载
      await new Promise((resolve) => setTimeout(resolve, 500))

      // 执行打印操作
      printFrame.contentWindow.print()
    },
  },
}
